"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promptDef = void 0;
exports.handle = handle;
const diagnostics_1 = require("../resources/diagnostics");
const summary_1 = require("../resources/summary");
exports.promptDef = {
    name: 'validate-state',
    description: 'Load project diagnostics and summary, return a prompt to review issues and propose fixes.',
    arguments: [],
};
async function handle(root, _args) {
    const [diagnostics, summary] = await Promise.all([
        (0, diagnostics_1.handleDiagnosticsResource)(root),
        (0, summary_1.handleSummaryResource)(root),
    ]);
    const diagText = diagnostics.contents[0].text;
    const summaryText = summary.contents[0].text;
    return {
        description: 'Loom state diagnostics review',
        messages: [
            {
                role: 'user',
                content: {
                    type: 'text',
                    text: `## Loom Diagnostics\n\n${diagText}\n\n## Summary\n\n${summaryText}`,
                },
            },
            {
                role: 'user',
                content: {
                    type: 'text',
                    text: 'Review the diagnostics and summary above. Identify issues (broken links, stale docs, orphaned documents, requirement scope-coverage gaps — uncovered Included reqs, steps citing an Excluded req, or dangling citations — and roadmap issues: depends_on cycles, dangling thread dependencies, or threads missing thread.md which need `loom migrate`) and propose concrete fixes using the available Loom tools.',
                },
            },
        ],
    };
}
